import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class ClearCacheService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public ClearCaches(keys: any) {
        return this.baseApiFactory.post<any>('/api/CacheManagement/Clear', keys);
    }

    public ClearCacheByKey(key: string) {
        return this.baseApiFactory.post<boolean>('/api/CacheManagement/Clear/' + key, {});
    }

    public GetCacheConfig() {
        return this.baseApiFactory.getData<any>('/api/CacheManagement/config');
    }

    public SelectCaches(query: {}) {
        return this.baseApiFactory.getData<any[]>('/api/CacheManagement', query);
    }
}

lazyRegister.service('ClearCacheService', ClearCacheService);
